export default __webpack_public_path__ + "static/media/CADV.a8c3443b.png";